
// import React, { useState, useEffect } from 'react';
// import { useNavigate, useLocation } from "react-router-dom";
// import { Button, Rate, Input, Tabs, Table, message, Modal, Collapse } from 'antd';
// import Swal from 'sweetalert2';
// import axios from 'axios';
// import { TiEyeOutline } from 'react-icons/ti';

// import useAuth from '../hooks/useAuth';
// import FeedbackToDevelopers from './FeedbackToDevelopers';

// const { TabPane } = Tabs;
// const URL = process.env.REACT_APP_API_URL;

// const Panelist = () => {
//   const { Panel } = Collapse;

//   const navigateTo = useNavigate();
//   const location = useLocation();
//   const auth = location.state.auth;
//   const candidateData = location.state.passCandidate;
//   const { token } = useAuth();

//   const [rounds, setRounds] = useState([]);
//   const [rating, setRating] = useState({});
//   const [dataEngineerStatus, setDataEngineerStatus] = useState('');
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [isDeveloperModalVisible, setIsDeveloperModalVisible] = useState(false);
//   const [testStatuses, setTestStatuses] = useState({});
//   const [selectedTest, setSelectedTest] = useState('');

//   const [formData, setFormData] = useState({
//     position: '',
//     fullName: '',
//     totalExperience: '',
//     noticePeriod: '',
//     panelistName: '',
//     feedback: '',
//     comments: '',
//     role: 'Applicant',
//     designationProposed: ''
//   });
//   const [isFeedbackGiven, setIsFeedbackGiven] = useState(false);


//   const handleBackButton = (e) => {
//     // e.preventDefault();
//     navigateTo("/feedbacks")
//   }

//   useEffect(() => {
//     if (candidateData) {
//       setFormData((prevData) => ({
//         ...prevData,
//         position: candidateData.position || '',
//         fullName: candidateData.fullName || '',
//         totalExperience: candidateData.totalExperience || '',
//         noticePeriod: candidateData.noticePeriod || '',
//         panelistName: candidateData.panelistName || '',
//         feedback: candidateData.feedback || '',
//       }));

//       // Get the latest round for each of L1, L2, and HR
//       const roundNames = ['L1', 'L2', 'L3', 'L4'];
//       const filteredRounds = roundNames.map(roundName => {
//         const latestRound = candidateData.round
//           .filter(round => round.roundName === roundName)
//           .sort((a, b) => new Date(b.interviewDate) - new Date(a.interviewDate))[0]; // sort by date and get latest
//         return latestRound;
//       }).filter(Boolean); // Filter out undefined values

//       setRounds(filteredRounds);

//       // Initialize skill ratings
//       const skillsData = filteredRounds.reduce((acc, round) => {
//         round.skills.forEach(skill => {
//           acc[`${skill.name.toLowerCase()}_${round.roundName}`] = skill.rating;
//         });
//         return acc;
//       }, {});
//       setRating(skillsData);

//       // Check if feedback is already given for all rounds
//       if (candidateData.status === 'Selected' || candidateData.status === 'Rejected' || filteredRounds.some(round => round.feedbackProvided)) {
//         setIsFeedbackGiven(true);
//       }
//     }
//     console.log("Candidate Data:", candidateData);
//   }, [candidateData]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     console.log('name: ', name);
//     console.log('value: ', value);

//     setFormData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };

//   const sendRejectionEmail = async (emailDetails) => {
//     try {
//       await axios.post(`${URL}/api/send-rejection-email`, emailDetails, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       message.success('Rejection email sent successfully');
//     } catch (error) {
//       console.error('Error sending rejection email:', error);
//       message.error('Failed to send rejection email. Please try again later.');
//     }
//   };

//   // const sendSelectionEmail = async (emailDetails) => {
//   //   try {
//   //     await axios.post(`${URL}/api/send-selection-email`, emailDetails, {
//   //       headers: {
//   //         Authorization: `Bearer ${token}`,
//   //       },
//   //     });
//   //     message.success('Selection email sent successfully');
//   //   } catch (error) {
//   //     console.error('Error sending selection email:', error);
//   //     message.error('Failed to send selection email. Please try again later.');
//   //   }
//   // };

//   // const sendSelectionEmail = async (emailDetails) => {
//   //   try {
//   //     await axios.post(`${URL}/api/selection-process-email`, emailDetails, {
//   //       headers: {
//   //         Authorization: `Bearer ${token}`,
//   //       },
//   //     });
//   //     message.success('Selection email sent successfully');
//   //   } catch (error) {
//   //     console.error('Error sending selection email:', error);
//   //     message.error('Failed to send selection email. Please try again later.');
//   //   }
//   // };

//   const sendSelectionEmail = async (emailDetails) => {
//     try {
//       console.log("Sending email request:", emailDetails);

//       const response = await axios.post(`${URL}/api/selection-process-email`, emailDetails, {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       if (response.status === 200) {
//         console.log("Email sent successfully:", response.data);
//       } else {
//         throw new Error("Failed to send email.");
//       }
//     } catch (error) {
//       console.error("Error sending selection email:", error.response?.data || error.message);
//     }
//   };

//   const sendFeedbackEmail = async (emailDetails) => {
//     try {
//       await axios.post(`${URL}/api/panelist-feedback`, emailDetails, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       message.success('Email sent successfully');
//     } catch (error) {
//       console.error('Error sending email:', error);
//       message.error('Failed to send email. Please try again later.');
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!candidateData || !candidateData._id) {
//       Swal.fire({
//         title: "Error",
//         text: "Candidate data is not available.",
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//       return;
//     }

//     const { feedback, panelistName, isFinalRound } = formData;

//     if (!feedback) {
//       Swal.fire({
//         title: "Error",
//         text: "Feedback is required.",
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//       return;
//     }

//     const currentRoundIndex = rounds.length - 1;
//     const currentRound = rounds[currentRoundIndex];

//     for (let skill of currentRound.skills) {
//       const ratingKey = `${skill.name.toLowerCase()}_${currentRound.roundName}`;
//       const commentKey = `${skill.name.toLowerCase()}Comments${currentRound.roundName}`;

//       const ratingValue = rating[ratingKey];


//       if (!ratingValue || ratingValue === 0) {
//         Swal.fire({
//           title: "Validation Error",
//           text: "Please fill the mandatory fields",
//           icon: "error",
//           confirmButtonText: "OK",
//         });
//         return;
//       }
//     }

//     let updatedTatHistory = candidateData.tatHistory.map(tat => ({ ...tat }));

//     if (isFinalRound && feedback.includes("Shortlisted for Offer")) {
//       updatedTatHistory = updatedTatHistory.map(tat => {
//         if (tat.tatType === "OPS TAT" && !tat.endDate) {
//           return {
//             ...tat,
//             endDate: new Date().toISOString(),
//             tatStatus: feedback,
//           };
//         }
//         return tat;
//       });

//       updatedTatHistory.push({
//         tatType: "HR TAT",
//         startDate: new Date().toISOString(),
//         tatStatus: feedback,
//       });
//     } else {
//       updatedTatHistory = updatedTatHistory.map(tat => {
//         if (tat.tatType === "HR TAT" && !tat.endDate && feedback.includes("L1")) {
//           return {
//             ...tat,
//             endDate: new Date().toISOString(),
//             tatStatus: feedback,
//           };
//         }
//         if (tat.tatType === "OPS TAT" && !tat.endDate && (feedback.includes("L2") || feedback.includes("Cleared") || feedback.includes("L3"))) {
//           return {
//             ...tat,
//             tatStatus: feedback,
//           };
//         }
//         return tat;
//       });
//     }

//     const updatedRounds = rounds.map((round, index) => {
//       if (index === currentRoundIndex) {
//         return {
//           ...round,
//           feedbackProvided: true,
//           panelistName: panelistName || auth.fullName,
//           interviewDate: round.interviewDate || new Date(),
//           skills: round.skills.map(skill => ({
//             ...skill,
//             rating: rating[`${skill.name.toLowerCase()}_${round.roundName}`] || 0,
//             comments: formData[`${skill.name.toLowerCase()}Comments${round.roundName}`] || skill.comments,
//           })),
//           feedback: feedback,
//         };
//       }
//       return round;
//     });

//     const roundIndex = currentRoundIndex;
//     const isShortlisted = isFinalRound && (feedback.includes("Shortlisted for Offer") || feedback.includes("Cleared"));

//     const requestBody = {
//       roundIndex,
//       feedback: updatedRounds[roundIndex].feedback,
//       feedbackProvided: updatedRounds[roundIndex].feedbackProvided,
//       skills: updatedRounds[roundIndex].skills,
//       panelistName: updatedRounds[roundIndex].panelistName,
//       tatHistoryUpdates: updatedTatHistory,
//       status: feedback,
//       isFinalRound: isFinalRound || false,
//       isShortlisted,
//     };

//     const emailDetails = {
//       candidateName: candidateData.fullName,
//       jobId: candidateData.jobId || "N/A",
//       candidatePosition: candidateData.position,
//       candidateEmail: candidateData.email,
//       feedback: updatedRounds[roundIndex].feedback,
//       panelistName: updatedRounds[roundIndex].panelistName,
//       panelistEmail: updatedRounds[roundIndex].panelistEmail,
//       tatHistoryUpdates: updatedTatHistory,
//       status: feedback || "Status Not Provided",
//       isFinalRound: isFinalRound || false,
//       isShortlisted,
//       roundName: updatedRounds[roundIndex]?.roundName || "Round Not Specified",
//       interviewDate: updatedRounds[roundIndex]?.scheduledDate || "Date Not Provided",
//       hrEmail: candidateData.hrEmail,
//       mgrEmail: candidateData.mgrEmail,
//       postedBy: panelistName || "Recruitment Team",
//     };

//     try {
//       const response = await axios.put(`${URL}/api/update-feedback/${candidateData._id}`, requestBody, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       if (response.status === 200) {

//         await sendFeedbackEmail(emailDetails);
//         const feedbackLower = feedback.toLowerCase();
//         if (feedbackLower.includes("rejected")) {
//           await sendRejectionEmail(emailDetails);
//         } else if (feedbackLower.includes("cleared")) {
//           await sendSelectionEmail(emailDetails);
//         }

//         // After all emails
//         Swal.fire({
//           title: "Success",
//           text: "Interview feedback updated successfully.",
//           icon: "success",
//           confirmButtonText: "OK",
//         }).then(() => {
//           setIsFeedbackGiven(true);
//           navigateTo("/feedbacks");
//         });
//       } else {
//         throw new Error("Failed to update feedback. Please try again later.");
//       }
//     } catch (error) {
//       console.error("Error updating feedback:", error);
//       Swal.fire({
//         title: "Error",
//         text: error.message || "Failed to update feedback. Please try again later.",
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//   };



//   const capitalizeAndFormat = (text) => {
//     const capitalizedWord = text.charAt(0).toUpperCase() + text.slice(1).split('_').join(' ');
//     return capitalizedWord;
//   }

//   const handleRateChange = (value, skillName, roundName) => {
//     setRating((prevRating) => ({
//       ...prevRating,
//       [`${skillName.toLowerCase()}_${roundName}`]: value, // Store the updated rating
//     }));
//     console.log("Rating changed:", skillName, roundName, value);
//   };

//   const scoreData = candidateData.selectedCategory === "ANI-Test" ? candidateData.aniTests.map(test => ({
//     name: test,
//     status: candidateData[test]?.status || 'Not Available'
//   })
//   ) : candidateData.selectedCategory === "Technical" ? [
//     { name: 'Psychometric', score: candidateData.psychometric.score === -1 ? 0 : candidateData.psychometric.score },
//     { name: 'Java', score: candidateData.java.score === -1 ? 0 : candidateData.java.score },
//     { name: 'Quantitative Aptitude', score: candidateData.quantitative.score === -1 ? 0 : candidateData.quantitative.score },
//     { name: 'Vocabulary', score: candidateData.vocabulary.score === -1 ? 0 : candidateData.vocabulary.score },
//   ] : [
//     { name: 'Psychometric', score: candidateData.psychometric.score === -1 ? 0 : candidateData.psychometric.score },
//     { name: 'Excel', score: candidateData.excel.score === -1 ? 0 : candidateData.excel.score },
//     { name: 'Accounts', score: candidateData.accounts.score === -1 ? 0 : candidateData.accounts.score },
//     { name: 'Vocabulary', score: candidateData.vocabulary.score === -1 ? 0 : candidateData.vocabulary.score },
//   ];

//   const answersData = selectedTest ? candidateData[selectedTest].answers.map(answer => ({
//     questionId: answer.questionId || 'N/A',
//     question: answer.question || "Not Available",
//     answer: answer.answer || 'Not Available'
//   }))
//     :
//     [];

//   // console.log('answersData', answersData);
//   // console.log('length of answers array: ', candidateData[selectedTest].answers.length );


//   const handleStatusChange = async (newStatus) => {
//     // console.log('testName: ', testName);

//     // Example: call API or update local state
//     // console.log(`Set ${testName} to ${newStatus}`);

//     candidateData[selectedTest].status = newStatus;

//     const response = await axios.patch(`${URL}/api/updateCandidateData/${candidateData._id}`, candidateData, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     });
//     console.log('response: ', response);

//     if (response.status === 200)
//       message.success('Candidate Data Updated Successfully!');
//     else
//       message.error('Sorry! Could not update candidate data.');

//     setTestStatuses(prev => ({
//       ...prev,
//       [selectedTest]: newStatus,
//     }));

//     setSelectedTest('');
//     setIsModalVisible(false);

//     // if (testName === "data_Engineer") {
//     //   setDataEngineerStatus(newStatus);
//     // }
//   };

//   const handleActionClick = (testName) => {
//     console.log('estName: ', testName);
//     setSelectedTest(testName);
//     setIsModalVisible(true);
//   }

//   const allowedTestsWithButtons = ["data_Engineer", "power_Bi_And_Data_Science", "gen_AI", "gen_AI_Theory", "big_Query"];

//   const scoreColumns = candidateData.aniTests.length > 0 ?
//     [
//       {
//         title: 'Test Name',
//         dataIndex: 'name',
//         key: 'name',
//         render: (text) => capitalizeAndFormat(text),
//       },
//       // {
//       //   title: 'Status / Action',
//       //   key: 'action',
//       //   render: (_, record) => {
//       //     const status = testStatuses[record.name] || record.status || 'Not Available';
//       //     const isButtonTest = allowedTestsWithButtons.includes(record.name) && record.status === "Attempted";
//       //     console.log('isButtonTest', isButtonTest);
//       //     console.log('record.name', record.name);
//       //     if (isButtonTest) {
//       //       return (
//       //         <div style={{ display: 'flex', gap: '8px' }}>
//       //           <Button style={{ backgroundColor: 'lightgreen' }} onClick={() => handleStatusChange(record.name, 'Pass')}>Pass</Button>
//       //           <Button style={{ backgroundColor: '#FF7276' }} onClick={() => handleStatusChange(record.name, 'Fail')}>Fail</Button>
//       //         </div>
//       //       );
//       //     } else {
//       //       return <span>{status || 'Not Available'}</span>;
//       //     }
//       //   },
//       // },
//       {
//         title: 'Status',
//         // dataIndex: 'status',
//         key: 'status',
//         render: (_, record) => {
//           const isSpecialTest = allowedTestsWithButtons.includes(record.name);
//           const status = isSpecialTest
//             ? testStatuses[record.name] || record.status || 'Not Available'
//             : record.status || 'Not Available';

//           return <span>{status}</span>;
//         }
//       },
//       {
//         title: 'Action',
//         key: 'action',
//         render: (_, record) => {
//           const isButtonTest = allowedTestsWithButtons.includes(record.name) && record.status === "Attempted";
//           if (isButtonTest) {
//             return (
//               <Button onClick={() => { handleActionClick(record.name) }}><TiEyeOutline /></Button>
//             )
//           }
//           else {
//             return (
//               <p>---------</p>
//             )
//           }
//         }
//       }
//       // {
//       //   title: 'Assign Status',
//       //   key: 'action',
//       //   render: (_, record) => (
//       //     <div style={{ display: 'flex', gap: '8px' }}>
//       //       <Button style={{backgroundColor: 'lightgreen'}} onClick={() => handleStatusChange(record.name, 'Pass')}>Pass</Button>
//       //       <Button style={{backgroundColor: 'lightred'}} onClick={() => handleStatusChange(record.name, 'Fail')}>Fail</Button>
//       //     </div>
//       //   ),
//       // },
//     ]
//     :
//     [
//       {
//         title: 'Test Name',
//         dataIndex: 'name',
//         key: 'name',
//       },
//       {
//         title: 'Score',
//         dataIndex: 'score',
//         key: 'score',
//       },
//     ];

//   const answerColumns = [
//     // {
//     //   title: 'Question Id',
//     //   dataIndex: 'questionId',
//     //   key: 'questionId',
//     // },
//     {
//       title: 'Question',
//       dataIndex: 'question',
//       key: 'question',
//     },
//     {
//       title: 'Answers',
//       dataIndex: 'answer',
//       key: 'answer',
//     },
//   ]

//   const panelHeaderStyle = {
//     color: "white",
//     textTransform: "capitalize",
//   };


//   return (
//     <>
//     <div className='modalContent'>
//       {candidateData && (
//         <>
//           <strong>
//             <p style={{ fontWeight: 'bold', fontSize: 18, color: '#00B4D2' }}>Candidate Name: {candidateData.fullName} for the role {candidateData.position}</p><br />
//             <p style={{ fontWeight: 'bold', fontSize: 16 }}>Total Experience: {candidateData.totalExperience}</p>
//             <p style={{ fontWeight: 'bold', fontSize: 16 }}>Availability / Notice Period: {candidateData.noticePeriod}</p><br />
//           </strong>
//         </>
//       )}
//       <Tabs style={{ backgroundColor: 'white', padding: '10px', borderRadius: '8px' }}>
//         <TabPane tab="Scores" key="scores">
//           <Table
//             columns={scoreColumns}
//             dataSource={scoreData}
//             pagination={false}
//             rowKey="name"
//           />
//         </TabPane>
//         {rounds.map((round, index) => (
//           <TabPane tab={round.roundName} key={index}>
//             {/* <div style={{ display: 'flex', flexDirection: 'row', alignItems: "center", justifyContent: 'space-between' }}> */}
//             {/* <p style={{ fontWeight: 'bold', fontSize: 14 }}>Interviewed by {round.panelistName} on {new Date(round.interviewDate).toLocaleDateString()}</p> */}
//             <p style={{ fontWeight: 'bold', fontSize: 14 }}>
//   {round.interviewDate 
//     ? `Interviewed by ${round.panelistName} on ${new Date(round.interviewDate).toLocaleDateString()}`
//     : `Interviewed by ${round.panelistName}`}
// </p>
//             {
//               round.feedbackProvided && (
//                 <p style={{ color: 'red', fontWeight: 'bold', fontSize: 14 }}>Feedback is already given for this round</p>
//               )
//             }
//             <p style={{ fontWeight: 'bold', fontSize: 14 }}> Feedback Provided: {round.feedbackProvided ? 'Yes' : 'Not yet'}</p>
//             <br />

//             <table className='panelistTable'>
//               <thead>
//                 <tr>
//                   <th>Questions</th>
//                   <th>Rating out of 5<span style={{ color: 'red' }}> *</span></th>
//                   <th>Comments</th> 
//                 </tr>
//               </thead>
//               <tbody>
//                 {round.skills.map((skill, idx) => (
//                   <tr key={idx}>
//                     <td>{skill.name}</td>
//                     <td>
//                       <Rate
//                         value={rating[`${skill.name.toLowerCase()}_${round.roundName}`] || 0}
//                         onChange={(value) => handleRateChange(value, skill.name, round.roundName)}
//                         disabled={round.feedbackProvided || index !== rounds.length - 1}
//                       />
//                     </td>
//                     <td>
//                       <Input.TextArea
//                         required={true}
//                         value={formData[`${skill.name.toLowerCase()}Comments${round.roundName}`] || (skill.comments && skill.comments !== 'No comments' ? skill.comments : '')}
//                         onChange={(e) => {

//                             setFormData({
//                               ...formData,
//                               [`${skill.name.toLowerCase()}Comments${round.roundName}`]: e.target.value,
//                             })
//                           }}
//                           disabled={round.feedbackProvided || index !== rounds.length - 1}
//                         />
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//               {round.roundName !== "L1" && (
//                 <>
//                   <div>
//                     <label>
//                       <input
//                         type="checkbox"
//                         name="isFinalRound"
//                         checked={formData.isFinalRound || false}
//                         onChange={(e) =>
//                           setFormData((prevData) => ({
//                             ...prevData,
//                             isFinalRound: e.target.checked,
//                           }))
//                         }
//                       />
//                       Is this the Final Round of Interview?
//                     </label>
//                   </div>
//                   <div>
//                     <label>Designation Proposed: </label>
//                     <Input
//                       type='text'
//                       name='designationProposed'
//                       onChange={handleChange}
//                       value={formData.designationProposed || ''}
//                       style={{ width: '290px' }}
//                     />
//                   </div>
//                 </>
//               )}

//               {index === rounds.length - 1 && !round.feedbackProvided && (
//                 <div className='panelistTable'>
//                   <label htmlFor='extraComments'>Extra Comments:</label>
//                   <Input.TextArea name='extraComments' value={formData.extraComments} onChange={handleChange} />
//                   <label htmlFor='feedback'>Final Feedback:</label>
//                   <select name='feedback' value={formData.feedback} onChange={handleChange}>
//                     <option value=''>Select Feedback</option>
//                     {round.roundName === 'L1' && (
//                       <>
//                         <option value='L1 Interview Cleared'>L1-HR Interview Cleared</option>
//                         <option value='L1 Interview Rejected'>L1-HR Interview Rejected</option>
//                         <option value='L1 Interview Hold'>L1-HR Interview Hold</option>
//                       </>
//                     )}
//                     {round.roundName === 'L2' && (
//                       <>
//                         <option value='L2 Interview Cleared'>L2 Interview Cleared</option>
//                         <option value='L2 Interview Rejected'>L2 Interview Rejected</option>
//                         <option value='L2 Interview Hold'>L2 Interview Hold</option>
//                       </>
//                     )}
//                     {round.roundName === 'L3' && (
//                       <>
//                         <option value='L3 Interview Cleared'>L3 Interview Cleared</option>
//                         <option value='L3 Interview Rejected'>L3 Interview Rejected</option>
//                         <option value='L3 Interview Hold'>L3 Interview Hold</option>
//                       </>
//                     )}
//                     {round.roundName === 'L4' && (
//                       <>
//                         <option value='L4 Interview Cleared'>L4 Interview Cleared</option>
//                         <option value='L4 Interview Rejected'>L4 Interview Rejected</option>
//                         <option value='L4 Interview Hold'>L4 Interview Hold</option>
//                       </>
//                     )}
//                     {formData.isFinalRound && (
//                       <option value='Shortlisted for Offer'>Shortlisted for Offer</option>
//                     )}

//                   </select>
//                 </div>
//               )}

//               {index === rounds.length - 1 && !round.feedbackProvided && (
//                 <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
//                   <div id='panelistbtn' onClick={handleBackButton}>
//                     <center><Button type='button' style={{ background: '#A50707' }} className='add-button'>Back</Button></center>
//                   </div>
//                   <div id='panelistbtn' onClick={handleSubmit}>
//                     <center><Button style={{ background: '#1677ff', marginLeft: 30 }} className='add-button'>Submit</Button></center>
//                   </div>
//                 </div>
//               )}
//             </TabPane>
//           ))
//           }
//         </Tabs>
//       </div>
//       <Modal
//         open={isModalVisible}
//         footer={null}
//         width={750}
//         // onCloseIcon={() => setIsModalVisible(false)}
//         onCancel={() => setIsModalVisible(false)}
//       >
//         <h1>{capitalizeAndFormat(selectedTest)}</h1><br />
//         {/* <Table
//           columns={answerColumns}
//           dataSource={answersData}
//           pagination={false}
//           rowKey="questionId"
//         /> */}
//         {/* {selectedTest ? (
//           candidateData[selectedTest].answers.map(answer => (
//             <>
//               <h1>Question</h1>
//               <p>{answer.question || "Not Available"}</p>
//               <br />
//               <h1>Answer</h1>
//               <p>{answer.answer}</p>
//               <br />
//             </>
//           ))) : (
//           <p>Loading data...</p>
//         )}
//         <br /> */}
//         {selectedTest ? (
//           <Collapse defaultActiveKey={"1"} accordion>
//             {candidateData[selectedTest].answers.map((answer, index) => (
//               <Panel
//                 header={<span style={panelHeaderStyle}>{answer.question}</span>}
//                 key={String(index + 1)}
//                 style={{ backgroundColor: "#007d93" }}
//               >
//                 {/* <span >{answer.answer}</span> */}
//                 <span>
//                   {answer.answer
//                     .replace(/(?=#)/g, '\n')   // insert newline before #
//                     .replace(/(?<!\n)(?=\bfrom\b)/g, '\n')
//                     //.replace(/(?=\bfrom\b)/g, '\n') // insert newline before the word "from"
//                     .split('\n')               // split by newline
//                     .map((line, i) => (
//                       <React.Fragment key={i}>
//                         {i !== 0 && <br />}
//                         {line}
//                       </React.Fragment>
//                     ))
//                   }
//                   {/* {
//                     answer.answer.includes('#') ?
//                       (
//                         answer.answer.split('#').map((line, i) => (
//                           <React.Fragment key={i}>
//                             {i !== 0 && <br />}{line}
//                           </React.Fragment>
//                         ))
//                       ) : (
//                         <span >{answer.answer}</span>
//                       )
//                   } */}
//                 </span>
//               </Panel>
//             ))}
//           </Collapse>
//         ) : (
//           <p>Loading data...</p>
//         )}

//         <br />
//         <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
//           <Button style={{ backgroundColor: 'lightgreen' }} onClick={() => handleStatusChange('Pass')}>Pass</Button>
//           <Button style={{ backgroundColor: '#FF7276' }} onClick={() => handleStatusChange('Fail')}>Fail</Button>
//         </div>
//       </Modal>
//       <Modal
//         title={`Report any queries to Developers`}
//         open={isDeveloperModalVisible}
//         onCancel={() => { setIsDeveloperModalVisible(false) }}
//         footer={null}
//       >
//         <FeedbackToDevelopers />
//       </Modal>
//       {/* {
//         isModalVisible &&
//         <>
//           <h1>Hello Universe! </h1>
//           <Button onClick={() => setIsModalVisible(false)}>Close</Button>
//         </>
//       } */}
//     </>
//   );
// };

// export default Panelist;  


import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Rate, Input, Tabs, Table, message, Modal, Collapse } from 'antd';
import Swal from 'sweetalert2';
import axios from 'axios';
import { TiEyeOutline } from 'react-icons/ti';

import useAuth from '../hooks/useAuth';
import FeedbackToDevelopers from './FeedbackToDevelopers';

const { TabPane } = Tabs;
const URL = process.env.REACT_APP_API_URL;

const Panelist = () => {
  const { Panel } = Collapse;

  const navigateTo = useNavigate();
  const location = useLocation();
  const auth = location.state.auth;
  const candidateData = location.state.passCandidate;
  const { token } = useAuth();

  const [rounds, setRounds] = useState([]);
  const [rating, setRating] = useState({});
  const [dataEngineerStatus, setDataEngineerStatus] = useState('');
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isDeveloperModalVisible, setIsDeveloperModalVisible] = useState(false);
  const [testStatuses, setTestStatuses] = useState({});
  const [selectedTest, setSelectedTest] = useState('');

  const [formData, setFormData] = useState({
    position: '',
    fullName: '',
    totalExperience: '',
    noticePeriod: '',
    panelistName: '',
    feedback: '',
    comments: '',
    role: 'Applicant',
    designationProposed: ''
  });
  const [isFeedbackGiven, setIsFeedbackGiven] = useState(false);


  const handleBackButton = (e) => {
    // e.preventDefault();
    navigateTo("/feedbacks")
  }

  useEffect(() => {
    if (candidateData) {
      setFormData((prevData) => ({
        ...prevData,
        position: candidateData.position || '',
        fullName: candidateData.fullName || '',
        totalExperience: candidateData.totalExperience || '',
        noticePeriod: candidateData.noticePeriod || '',
        panelistName: candidateData.panelistName || '',
        feedback: candidateData.feedback || '',
      }));

      // Get the latest round for each of L1, L2, and HR
      const roundNames = ['L1', 'L2', 'L3', 'L4'];
      const filteredRounds = roundNames.map(roundName => {
        const latestRound = candidateData.round
          .filter(round => round.roundName === roundName)
          .sort((a, b) => new Date(b.interviewDate) - new Date(a.interviewDate))[0]; // sort by date and get latest
        return latestRound;
      }).filter(Boolean); // Filter out undefined values

      setRounds(filteredRounds);

      // Initialize skill ratings
      const skillsData = filteredRounds.reduce((acc, round) => {
        round.skills.forEach(skill => {
          acc[`${skill.name.toLowerCase()}_${round.roundName}`] = skill.rating;
        });
        return acc;
      }, {});
      setRating(skillsData);

      // Check if feedback is already given for all rounds
      if (candidateData.status === 'Selected' || candidateData.status === 'Rejected' || filteredRounds.some(round => round.feedbackProvided)) {
        setIsFeedbackGiven(true);
      }
    }
    console.log("Candidate Data:", candidateData);
  }, [candidateData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log('name: ', name);
    console.log('value: ', value);

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const sendRejectionEmail = async (emailDetails) => {
    try {
      await axios.post(`${URL}/api/send-rejection-email`, emailDetails, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      message.success('Rejection email sent successfully');
    } catch (error) {
      console.error('Error sending rejection email:', error);
      message.error('Failed to send rejection email. Please try again later.');
    }
  };

  // const sendSelectionEmail = async (emailDetails) => {
  //   try {
  //     await axios.post(`${URL}/api/send-selection-email`, emailDetails, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });
  //     message.success('Selection email sent successfully');
  //   } catch (error) {
  //     console.error('Error sending selection email:', error);
  //     message.error('Failed to send selection email. Please try again later.');
  //   }
  // };

  // const sendSelectionEmail = async (emailDetails) => {
  //   try {
  //     await axios.post(`${URL}/api/selection-process-email`, emailDetails, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });
  //     message.success('Selection email sent successfully');
  //   } catch (error) {
  //     console.error('Error sending selection email:', error);
  //     message.error('Failed to send selection email. Please try again later.');
  //   }
  // };

  const sendSelectionEmail = async (emailDetails) => {
    try {
      console.log("Sending email request:", emailDetails);

      const response = await axios.post(`${URL}/api/selection-process-email`, emailDetails, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) {
        console.log("Email sent successfully:", response.data);
      } else {
        throw new Error("Failed to send email.");
      }
    } catch (error) {
      console.error("Error sending selection email:", error.response?.data || error.message);
    }
  };

  const sendFeedbackEmail = async (emailDetails) => {
    try {
      await axios.post(`${URL}/api/panelist-feedback`, emailDetails, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      message.success('Email sent successfully');
    } catch (error) {
      console.error('Error sending email:', error);
      message.error('Failed to send email. Please try again later.');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!candidateData || !candidateData._id) {
      Swal.fire({
        title: "Error",
        text: "Candidate data is not available.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    const { feedback, panelistName, isFinalRound } = formData;

    if (!feedback) {
      Swal.fire({
        title: "Error",
        text: "Feedback is required.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    const currentRoundIndex = rounds.length - 1;
    const currentRound = rounds[currentRoundIndex];

    for (let skill of currentRound.skills) {
      const ratingKey = `${skill.name.toLowerCase()}_${currentRound.roundName}`;
      const commentKey = `${skill.name.toLowerCase()}Comments${currentRound.roundName}`;

      const ratingValue = rating[ratingKey];


      if (!ratingValue || ratingValue === 0) {
        Swal.fire({
          title: "Validation Error",
          text: "Please fill the mandatory fields",
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }
    }

   // 🔄 Update tatHistory based on feedback
    const updatedTatHistory = candidateData.tatHistory.map((tat) => {
      // ✅ Close HR TAT when L1 is cleared
      if (
        tat.tatType === "HR TAT" &&
        !tat.endDate &&
        feedback.includes("L1 Interview Cleared")
      ) {
        return { ...tat, endDate: new Date().toISOString(), tatStatus: feedback };
      }

      // ✅ Close OPS TAT when L2 is cleared
      if (
        tat.tatType === "OPS TAT" &&
        !tat.endDate &&
        feedback.includes("L2 Interview Cleared")
      ) {
        return { ...tat, endDate: new Date().toISOString(), tatStatus: feedback };
      }

      // ✅ Final round feedback from HR TAT only
      if (
        tat.tatType === "HR TAT" &&
        !tat.endDate &&
        isFinalRound &&
        (
          feedback.includes("L3 Interview Cleared") ||
          feedback.includes("Shortlisted for Offer") ||
          (feedback.toLowerCase().includes("rejected") && feedback.includes("L3"))
        )
      ) {
        return {
          ...tat,
          endDate: new Date().toISOString(),
          tatStatus: feedback.includes("Rejected") ? "L3 Interview Rejected" : feedback,
        };
      }

      // ❌ Close any remaining open TATs on rejection
      if (
        ["HR TAT", "OPS TAT"].includes(tat.tatType) &&
        !tat.endDate &&
        feedback.toLowerCase().includes("rejected")
      ) {
        return { ...tat, endDate: new Date().toISOString(), tatStatus: feedback };
      }

      return tat;
    });

    // 🔎 Duplication guards
    const hasL2 = updatedTatHistory.some(
      (t) => t.tatType === "OPS TAT" && t.tatStatus === "L2 Interview Cleared"
    );

    const hasFinalStatus = updatedTatHistory.some(
      (t) => t.tatType === "HR TAT" &&
        (
          t.tatStatus === "L3 Interview Cleared" ||
          t.tatStatus === "Shortlisted for Offer" ||
          t.tatStatus === "L3 Interview Rejected"
        )
    );

    // ➕ Ensure L2 is added before final round if skipped
    if (!hasL2 && feedback.includes("Shortlisted for Offer") && isFinalRound) {
      updatedTatHistory.push({
        tatType: "OPS TAT",
        startDate: new Date().toISOString(),
        endDate: new Date().toISOString(),
        tatStatus: "L2 Interview Cleared",
      });
    }

    // ➕ Add OPS TAT after L1 clears
    if (feedback.includes("L1 Interview Cleared")) {
      updatedTatHistory.push({
        tatType: "OPS TAT",
        startDate: new Date().toISOString(),
        tatStatus: feedback,
      });
    }

    // ➕ Add L2 if missing and not final
    if (!hasL2 && feedback.includes("L2 Interview Cleared") && !isFinalRound) {
      updatedTatHistory.push({
        tatType: "OPS TAT",
        startDate: new Date().toISOString(),
        endDate: new Date().toISOString(),
        tatStatus: "L2 Interview Cleared",
      });
    }

    // ➕ Push final status under HR TAT only
    if (
      !hasFinalStatus &&
      isFinalRound &&
      (
        feedback.includes("L3 Interview Cleared") ||
        feedback.includes("Shortlisted for Offer") ||
        (feedback.toLowerCase().includes("rejected") && feedback.includes("L3"))
      )
    ) {
      updatedTatHistory.push({
        tatType: "HR TAT", // ✅ Final status always comes from HR
        startDate: new Date().toISOString(),
        endDate: new Date().toISOString(),
        tatStatus: feedback.includes("Rejected") ? "L3 Interview Rejected" : feedback,
      });
    }


    // let updatedTatHistory = candidateData.tatHistory.map(tat => ({ ...tat }));

    // if (isFinalRound && feedback.includes("Shortlisted for Offer")) {
    //   updatedTatHistory = updatedTatHistory.map(tat => {
    //     if (tat.tatType === "OPS TAT" && !tat.endDate) {
    //       return {
    //         ...tat,
    //         endDate: new Date().toISOString(),
    //         tatStatus: feedback,
    //       };
    //     }
    //     return tat;
    //   });

    //   updatedTatHistory.push({
    //     tatType: "HR TAT",
    //     startDate: new Date().toISOString(),
    //     tatStatus: feedback,
    //   });
    // } else {
    //   updatedTatHistory = updatedTatHistory.map(tat => {
    //     if (tat.tatType === "HR TAT" && !tat.endDate && feedback.includes("L1")) {
    //       return {
    //         ...tat,
    //         endDate: new Date().toISOString(),
    //         tatStatus: feedback,
    //       };
    //     }
    //     if (tat.tatType === "OPS TAT" && !tat.endDate && (feedback.includes("L2") || feedback.includes("Cleared") || feedback.includes("L3"))) {
    //       return {
    //         ...tat,
    //         tatStatus: feedback,
    //       };
    //     }
    //     return tat;
    //   });
    // }

    const updatedRounds = rounds.map((round, index) => {
      if (index === currentRoundIndex) {
        return {
          ...round,
          feedbackProvided: true,
          panelistName: panelistName || auth.fullName,
          interviewDate: round.interviewDate || new Date(),
          skills: round.skills.map(skill => ({
            ...skill,
            rating: rating[`${skill.name.toLowerCase()}_${round.roundName}`] || 0,
            comments: formData[`${skill.name.toLowerCase()}Comments${round.roundName}`] || skill.comments,
          })),
          feedback: feedback,
        };
      }
      return round;
    });

    const roundIndex = currentRoundIndex;
    const isShortlisted = isFinalRound && (feedback.includes("Shortlisted for Offer") || feedback.includes("Cleared"));

    const requestBody = {
      roundIndex,
      feedback: updatedRounds[roundIndex].feedback,
      feedbackProvided: updatedRounds[roundIndex].feedbackProvided,
      skills: updatedRounds[roundIndex].skills,
      panelistName: updatedRounds[roundIndex].panelistName,
      tatHistoryUpdates: updatedTatHistory,
      status: feedback,
      isFinalRound: isFinalRound || false,
      isShortlisted,
    };

    const emailDetails = {
      candidateName: candidateData.fullName,
      jobId: candidateData.jobId || "N/A",
      candidatePosition: candidateData.position,
      candidateEmail: candidateData.email,
      feedback: updatedRounds[roundIndex].feedback,
      panelistName: updatedRounds[roundIndex].panelistName,
      panelistEmail: updatedRounds[roundIndex].panelistEmail,
      tatHistoryUpdates: updatedTatHistory,
      status: feedback || "Status Not Provided",
      isFinalRound: isFinalRound || false,
      isShortlisted,
      roundName: updatedRounds[roundIndex]?.roundName || "Round Not Specified",
      interviewDate: updatedRounds[roundIndex]?.scheduledDate || "Date Not Provided",
      hrEmail: candidateData.hrEmail,
      mgrEmail: candidateData.mgrEmail,
      postedBy: panelistName || "Recruitment Team",
    };

    try {
      const response = await axios.put(`${URL}/api/update-feedback/${candidateData._id}`, requestBody, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {

        await sendFeedbackEmail(emailDetails);
        const feedbackLower = feedback.toLowerCase();
        if (feedbackLower.includes("rejected")) {
          await sendRejectionEmail(emailDetails);
        } else if (feedbackLower.includes("cleared")) {
          await sendSelectionEmail(emailDetails);
        }

        // After all emails
        Swal.fire({
          title: "Success",
          text: "Interview feedback updated successfully.",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          setIsFeedbackGiven(true);
          navigateTo("/feedbacks");
        });
      } else {
        throw new Error("Failed to update feedback. Please try again later.");
      }
    } catch (error) {
      console.error("Error updating feedback:", error);
      Swal.fire({
        title: "Error",
        text: error.message || "Failed to update feedback. Please try again later.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };



  const capitalizeAndFormat = (text) => {
    const capitalizedWord = text.charAt(0).toUpperCase() + text.slice(1).split('_').join(' ');
    return capitalizedWord;
  }

  const handleRateChange = (value, skillName, roundName) => {
    setRating((prevRating) => ({
      ...prevRating,
      [`${skillName.toLowerCase()}_${roundName}`]: value, // Store the updated rating
    }));
    console.log("Rating changed:", skillName, roundName, value);
  };

  const scoreData = candidateData.selectedCategory === "ANI-Test" ? candidateData.aniTests.map(test => ({
    name: test,
    status: candidateData[test]?.status || 'Not Available'
  })
  ) : candidateData.selectedCategory === "Technical" ? [
    { name: 'Psychometric', score: candidateData.psychometric.score === -1 ? 0 : candidateData.psychometric.score },
    { name: 'Java', score: candidateData.java.score === -1 ? 0 : candidateData.java.score },
    { name: 'Quantitative Aptitude', score: candidateData.quantitative.score === -1 ? 0 : candidateData.quantitative.score },
    { name: 'Vocabulary', score: candidateData.vocabulary.score === -1 ? 0 : candidateData.vocabulary.score },
  ] : [
    { name: 'Psychometric', score: candidateData.psychometric.score === -1 ? 0 : candidateData.psychometric.score },
    { name: 'Excel', score: candidateData.excel.score === -1 ? 0 : candidateData.excel.score },
    { name: 'Accounts', score: candidateData.accounts.score === -1 ? 0 : candidateData.accounts.score },
    { name: 'Vocabulary', score: candidateData.vocabulary.score === -1 ? 0 : candidateData.vocabulary.score },
  ];

  const answersData = selectedTest ? candidateData[selectedTest].answers.map(answer => ({
    questionId: answer.questionId || 'N/A',
    question: answer.question || "Not Available",
    answer: answer.answer || 'Not Available'
  }))
    :
    [];

  // console.log('answersData', answersData);
  // console.log('length of answers array: ', candidateData[selectedTest].answers.length );


  const handleStatusChange = async (newStatus) => {
    // console.log('testName: ', testName);

    // Example: call API or update local state
    // console.log(`Set ${testName} to ${newStatus}`);

    candidateData[selectedTest].status = newStatus;

    const response = await axios.patch(`${URL}/api/updateCandidateData/${candidateData._id}`, candidateData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log('response: ', response);

    if (response.status === 200)
      message.success('Candidate Data Updated Successfully!');
    else
      message.error('Sorry! Could not update candidate data.');

    setTestStatuses(prev => ({
      ...prev,
      [selectedTest]: newStatus,
    }));

    setSelectedTest('');
    setIsModalVisible(false);

    // if (testName === "data_Engineer") {
    //   setDataEngineerStatus(newStatus);
    // }
  };

  const handleActionClick = (testName) => {
    console.log('estName: ', testName);
    setSelectedTest(testName);
    setIsModalVisible(true);
  }

  const allowedTestsWithButtons = ["data_Engineer", "power_Bi_And_Data_Science", "gen_AI", "gen_AI_Theory", "big_Query"];

  const scoreColumns = candidateData.aniTests.length > 0 ?
    [
      {
        title: 'Test Name',
        dataIndex: 'name',
        key: 'name',
        render: (text) => capitalizeAndFormat(text),
      },
      // {
      //   title: 'Status / Action',
      //   key: 'action',
      //   render: (_, record) => {
      //     const status = testStatuses[record.name] || record.status || 'Not Available';
      //     const isButtonTest = allowedTestsWithButtons.includes(record.name) && record.status === "Attempted";
      //     console.log('isButtonTest', isButtonTest);
      //     console.log('record.name', record.name);
      //     if (isButtonTest) {
      //       return (
      //         <div style={{ display: 'flex', gap: '8px' }}>
      //           <Button style={{ backgroundColor: 'lightgreen' }} onClick={() => handleStatusChange(record.name, 'Pass')}>Pass</Button>
      //           <Button style={{ backgroundColor: '#FF7276' }} onClick={() => handleStatusChange(record.name, 'Fail')}>Fail</Button>
      //         </div>
      //       );
      //     } else {
      //       return <span>{status || 'Not Available'}</span>;
      //     }
      //   },
      // },
      {
        title: 'Status',
        // dataIndex: 'status',
        key: 'status',
        render: (_, record) => {
          const isSpecialTest = allowedTestsWithButtons.includes(record.name);
          const status = isSpecialTest
            ? testStatuses[record.name] || record.status || 'Not Available'
            : record.status || 'Not Available';

          return <span>{status}</span>;
        }
      },
      {
        title: 'Action',
        key: 'action',
        render: (_, record) => {
          const isButtonTest = allowedTestsWithButtons.includes(record.name) && record.status === "Attempted";
          if (isButtonTest) {
            return (
              <Button onClick={() => { handleActionClick(record.name) }}><TiEyeOutline /></Button>
            )
          }
          else {
            return (
              <p>---------</p>
            )
          }
        }
      }
      // {
      //   title: 'Assign Status',
      //   key: 'action',
      //   render: (_, record) => (
      //     <div style={{ display: 'flex', gap: '8px' }}>
      //       <Button style={{backgroundColor: 'lightgreen'}} onClick={() => handleStatusChange(record.name, 'Pass')}>Pass</Button>
      //       <Button style={{backgroundColor: 'lightred'}} onClick={() => handleStatusChange(record.name, 'Fail')}>Fail</Button>
      //     </div>
      //   ),
      // },
    ]
    :
    [
      {
        title: 'Test Name',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'Score',
        dataIndex: 'score',
        key: 'score',
      },
    ];

  const answerColumns = [
    // {
    //   title: 'Question Id',
    //   dataIndex: 'questionId',
    //   key: 'questionId',
    // },
    {
      title: 'Question',
      dataIndex: 'question',
      key: 'question',
    },
    {
      title: 'Answers',
      dataIndex: 'answer',
      key: 'answer',
    },
  ]

  const panelHeaderStyle = {
    color: "white",
    textTransform: "capitalize",
  };


  return (
    <>
    <div className='modalContent'>
      {candidateData && (
        <>
          <strong>
            <p style={{ fontWeight: 'bold', fontSize: 18, color: '#00B4D2' }}>Candidate Name: {candidateData.fullName} for the role {candidateData.position}</p><br />
            <p style={{ fontWeight: 'bold', fontSize: 16 }}>Total Experience: {candidateData.totalExperience}</p>
            <p style={{ fontWeight: 'bold', fontSize: 16 }}>Availability / Notice Period: {candidateData.noticePeriod}</p><br />
          </strong>
        </>
      )}
      <Tabs style={{ backgroundColor: 'white', padding: '10px', borderRadius: '8px' }}>
        <TabPane tab="Scores" key="scores">
          <Table
            columns={scoreColumns}
            dataSource={scoreData}
            pagination={false}
            rowKey="name"
          />
        </TabPane>
        {rounds.map((round, index) => (
          <TabPane tab={round.roundName} key={index}>
            {/* <div style={{ display: 'flex', flexDirection: 'row', alignItems: "center", justifyContent: 'space-between' }}> */}
            {/* <p style={{ fontWeight: 'bold', fontSize: 14 }}>Interviewed by {round.panelistName} on {new Date(round.interviewDate).toLocaleDateString()}</p> */}
            <p style={{ fontWeight: 'bold', fontSize: 14 }}>
  {round.interviewDate 
    ? `Interviewed by ${round.panelistName} on ${new Date(round.interviewDate).toLocaleDateString()}`
    : `Interviewed by ${round.panelistName}`}
</p>
            {
              round.feedbackProvided && (
                <p style={{ color: 'red', fontWeight: 'bold', fontSize: 14 }}>Feedback is already given for this round</p>
              )
            }
            <p style={{ fontWeight: 'bold', fontSize: 14 }}> Feedback Provided: {round.feedbackProvided ? 'Yes' : 'Not yet'}</p>
            <br />

            <table className='panelistTable'>
              <thead>
                <tr>
                  <th>Questions</th>
                  <th>Rating out of 5<span style={{ color: 'red' }}> *</span></th>
                  <th>Comments</th> 
                </tr>
              </thead>
              <tbody>
                {round.skills.map((skill, idx) => (
                  <tr key={idx}>
                    <td>{skill.name}</td>
                    <td>
                      <Rate
                        value={rating[`${skill.name.toLowerCase()}_${round.roundName}`] || 0}
                        onChange={(value) => handleRateChange(value, skill.name, round.roundName)}
                        disabled={round.feedbackProvided || index !== rounds.length - 1}
                      />
                    </td>
                    <td>
                      <Input.TextArea
                        required={true}
                        value={formData[`${skill.name.toLowerCase()}Comments${round.roundName}`] || (skill.comments && skill.comments !== 'No comments' ? skill.comments : '')}
                        onChange={(e) => {

                            setFormData({
                              ...formData,
                              [`${skill.name.toLowerCase()}Comments${round.roundName}`]: e.target.value,
                            })
                          }}
                          disabled={round.feedbackProvided || index !== rounds.length - 1}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {round.roundName !== "L1" && (
                <>
                  <div>
                    <label>
                      <input
                        type="checkbox"
                        name="isFinalRound"
                        checked={formData.isFinalRound || false}
                        onChange={(e) =>
                          setFormData((prevData) => ({
                            ...prevData,
                            isFinalRound: e.target.checked,
                          }))
                        }
                      />
                      Is this the Final Round of Interview?
                    </label>
                  </div>
                  <div>
                    <label>Designation Proposed: </label>
                    <Input
                      type='text'
                      name='designationProposed'
                      onChange={handleChange}
                      value={formData.designationProposed || ''}
                      style={{ width: '290px' }}
                    />
                  </div>
                </>
              )}

              {index === rounds.length - 1 && !round.feedbackProvided && (
                <div className='panelistTable'>
                  <label htmlFor='extraComments'>Extra Comments:</label>
                  <Input.TextArea name='extraComments' value={formData.extraComments} onChange={handleChange} />
                  <label htmlFor='feedback'>Final Feedback:</label>
                  <select name='feedback' value={formData.feedback} onChange={handleChange}>
                    <option value=''>Select Feedback</option>
                    {round.roundName === 'L1' && (
                      <>
                        <option value='L1 Interview Cleared'>L1-HR Interview Cleared</option>
                        <option value='L1 Interview Rejected'>L1-HR Interview Rejected</option>
                        <option value='L1 Interview Hold'>L1-HR Interview Hold</option>
                      </>
                    )}
                    {round.roundName === 'L2' && (
                      <>
                        <option value='L2 Interview Cleared'>L2 Interview Cleared</option>
                        <option value='L2 Interview Rejected'>L2 Interview Rejected</option>
                        <option value='L2 Interview Hold'>L2 Interview Hold</option>
                      </>
                    )}
                    {round.roundName === 'L3' && (
                      <>
                        <option value='L3 Interview Cleared'>L3 Interview Cleared</option>
                        <option value='L3 Interview Rejected'>L3 Interview Rejected</option>
                        <option value='L3 Interview Hold'>L3 Interview Hold</option>
                      </>
                    )}
                    {round.roundName === 'L4' && (
                      <>
                        <option value='L4 Interview Cleared'>L4 Interview Cleared</option>
                        <option value='L4 Interview Rejected'>L4 Interview Rejected</option>
                        <option value='L4 Interview Hold'>L4 Interview Hold</option>
                      </>
                    )}
                    {formData.isFinalRound && (
                      <option value='Shortlisted for Offer'>Shortlisted for Offer</option>
                    )}

                  </select>
                </div>
              )}

              {index === rounds.length - 1 && !round.feedbackProvided && (
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                  <div id='panelistbtn' onClick={handleBackButton}>
                    <center><Button type='button' style={{ background: '#A50707' }} className='add-button'>Back</Button></center>
                  </div>
                  <div id='panelistbtn' onClick={handleSubmit}>
                    <center><Button style={{ background: '#1677ff', marginLeft: 30 }} className='add-button'>Submit</Button></center>
                  </div>
                </div>
              )}
            </TabPane>
          ))
          }
        </Tabs>
      </div>
      <Modal
        open={isModalVisible}
        footer={null}
        width={750}
        // onCloseIcon={() => setIsModalVisible(false)}
        onCancel={() => setIsModalVisible(false)}
      >
        <h1>{capitalizeAndFormat(selectedTest)}</h1><br />
        {/* <Table
          columns={answerColumns}
          dataSource={answersData}
          pagination={false}
          rowKey="questionId"
        /> */}
        {/* {selectedTest ? (
          candidateData[selectedTest].answers.map(answer => (
            <>
              <h1>Question</h1>
              <p>{answer.question || "Not Available"}</p>
              <br />
              <h1>Answer</h1>
              <p>{answer.answer}</p>
              <br />
            </>
          ))) : (
          <p>Loading data...</p>
        )}
        <br /> */}
        {selectedTest ? (
          <Collapse defaultActiveKey={"1"} accordion>
            {candidateData[selectedTest].answers.map((answer, index) => (
              <Panel
                header={<span style={panelHeaderStyle}>{answer.question}</span>}
                key={String(index + 1)}
                style={{ backgroundColor: "#007d93" }}
              >
                {/* <span >{answer.answer}</span> */}
                <span>
                  {answer.answer
                    .replace(/(?=#)/g, '\n')   // insert newline before #
                    .replace(/(?<!\n)(?=\bfrom\b)/g, '\n')
                    //.replace(/(?=\bfrom\b)/g, '\n') // insert newline before the word "from"
                    .split('\n')               // split by newline
                    .map((line, i) => (
                      <React.Fragment key={i}>
                        {i !== 0 && <br />}
                        {line}
                      </React.Fragment>
                    ))
                  }
                  {/* {
                    answer.answer.includes('#') ?
                      (
                        answer.answer.split('#').map((line, i) => (
                          <React.Fragment key={i}>
                            {i !== 0 && <br />}{line}
                          </React.Fragment>
                        ))
                      ) : (
                        <span >{answer.answer}</span>
                      )
                  } */}
                </span>
              </Panel>
            ))}
          </Collapse>
        ) : (
          <p>Loading data...</p>
        )}

        <br />
        <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
          <Button style={{ backgroundColor: 'lightgreen' }} onClick={() => handleStatusChange('Pass')}>Pass</Button>
          <Button style={{ backgroundColor: '#FF7276' }} onClick={() => handleStatusChange('Fail')}>Fail</Button>
        </div>
      </Modal>
      <Modal
        title={`Report any queries to Developers`}
        open={isDeveloperModalVisible}
        onCancel={() => { setIsDeveloperModalVisible(false) }}
        footer={null}
      >
        <FeedbackToDevelopers />
      </Modal>
      {/* {
        isModalVisible &&
        <>
          <h1>Hello Universe! </h1>
          <Button onClick={() => setIsModalVisible(false)}>Close</Button>
        </>
      } */}
    </>
  );
};

export default Panelist;  

